import { createFileRoute } from '@tanstack/react-router';
import { PartyRedirect } from '@/features/parties/PartyRedirect';

export const Route = createFileRoute('/app/contacts_/$contactId')({
  component: ContactRoute,
  staticData: { title: 'Person' },
});

function ContactRoute() {
  const { contactId } = Route.useParams();
  return <PartyRedirect key={contactId} kind="contact" id={contactId} />;
}
